import styled from 'styled-components';

const Browser = styled.a`
    color: var(--primary-dark);
    font-weight: 500;
    text-decoration: none;
`;

const BrowserContainer = styled.div`
    display: inline-flex;
    width: 250px;
`;

const Heading = styled.h1`
    font-size: 3.8rem;
`;

export function UnsupportedBrowser() {
    return (
        <>
            <Heading className="m-0">Browser not supported</Heading>
            <div>
                To utilize the full potential of SMARTdiagnostics, we recommend
                downloading one of the following supported browsers.
            </div>
            <BrowserContainer className="mt-20 justify-between">
                <Browser href="https://www.mozilla.org/en-US/firefox/">Firefox</Browser>
                <Browser href="https://www.google.com/chrome/">Chrome</Browser>
                <Browser href="https://www.microsoft.com/en-us/edge">Edge</Browser>
            </BrowserContainer>
        </>
    );
}
